import { render, staticRenderFns } from "./threecenter.vue?vue&type=template&id=5b5231a4&scoped=true&"
import script from "./threecenter.vue?vue&type=script&lang=js&"
export * from "./threecenter.vue?vue&type=script&lang=js&"
import style0 from "./threecenter.vue?vue&type=style&index=0&id=5b5231a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5231a4",
  null
  
)

export default component.exports